/** Error handling utilities. */

export class ApiError extends Error {
  constructor(
    message: string,
    public statusCode?: number,
    public response?: unknown
  ) {
    super(message);
    this.name = 'ApiError';
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export class NetworkError extends Error {
  constructor(message: string, public originalError?: Error) {
    super(message);
    this.name = 'NetworkError';
    Object.setPrototypeOf(this, NetworkError.prototype);
  }
}

export class ValidationError extends Error {
  constructor(message: string, public field?: string) {
    super(message);
    this.name = 'ValidationError';
    Object.setPrototypeOf(this, ValidationError.prototype);
  }
}

export function handleError(error: unknown): string {
  if (error instanceof ApiError) {
    return `API Error: ${error.message}${error.statusCode ? ` (${error.statusCode})` : ''}`;
  }
  if (error instanceof NetworkError) {
    return `Network Error: ${error.message}`;
  }
  if (error instanceof ValidationError) {
    return `Validation Error: ${error.message}${error.field ? ` (${error.field})` : ''}`;
  }
  if (error instanceof Error) {
    return error.message;
  }
  return 'An unknown error occurred';
}

export function isAbortError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  return error.name === 'AbortError' || /aborted/i.test(error.message);
}

export function logError(error: unknown, context?: string): void {
  const errorMessage = handleError(error);
  const logMessage = context ? `[${context}] ${errorMessage}` : errorMessage;
  console.error(logMessage, error);
}

